(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-opening-screen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[id^="about-opening-screen-"]');

    sections.forEach(function (container) {
      const framesWrapper = container.querySelector('.about-opening-screen__frames');
      const frames = container.querySelectorAll('.about-opening-screen__frame');
      const frameCount = frames.length;

      if (frameCount < 1) return;

      const movementThreshold = parseInt(container.dataset.movementThreshold, 10) || 200;
      const mobileInterval = parseInt(container.dataset.mobileInterval, 10) || 5000;
      const maxOffset = parseInt(container.dataset.maxOffset, 10) || 80;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let currentFrame = 0;
      let cumulativeDistance = 0;
      let lastX = null;
      let lastY = null;
      let isMobile = window.matchMedia('(max-width: 991px)').matches;
      let mobileTimer = null;

      function showFrame(index) {
        frames.forEach(function (frame, i) {
          const isActive = i === index;
          frame.classList.toggle('about-opening-screen__frame--active', isActive);
          frame.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }

      function advanceFrame() {
        currentFrame = (currentFrame + 1) % frameCount;
        showFrame(currentFrame);
      }

      const trackerArea = container.closest('section.main-aos') || container;

      /* --- Desktop: mouse tracking --- */
      function handleMouseMove(e) {
        if (isMobile) return;

        const rect = container.getBoundingClientRect();
        const trackRect = trackerArea.getBoundingClientRect();
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        const trackCenterX = trackRect.left + trackRect.width / 2;
        const trackCenterY = trackRect.top + trackRect.height / 2;

        const imgWidth = 205;
        const imgHeight = 236;
        
        const maxOffsetX = Math.max(0, (rect.width - imgWidth) / 2);
        const maxOffsetY = Math.max(0, (rect.height - imgHeight) / 2);

        // Calculate proportional movement based on whole trackerArea bounds
        let rangeX = (mouseX - trackCenterX) / (trackRect.width / 2);
        let rangeY = (mouseY - trackCenterY) / (trackRect.height / 2);

        // Clamp to prevent exceeding container edge
        rangeX = Math.max(-1, Math.min(1, rangeX));
        rangeY = Math.max(-1, Math.min(1, rangeY));

        const offsetX = rangeX * maxOffsetX;
        const offsetY = rangeY * maxOffsetY;

        if (!prefersReducedMotion) {
          frames.forEach(function (frame) {
            frame.style.transform =
              'translate(' + offsetX + 'px, ' + offsetY + 'px)';
          });
        }

        if (lastX !== null && lastY !== null) {
          const dx = mouseX - lastX;
          const dy = mouseY - lastY;
          cumulativeDistance += Math.sqrt(dx * dx + dy * dy);

          if (cumulativeDistance >= movementThreshold) {
            advanceFrame();
            cumulativeDistance = 0;
          }
        }

        lastX = mouseX;
        lastY = mouseY;
      }

      function handleMouseLeave() {
        lastX = null;
        lastY = null;
        cumulativeDistance = 0;

        if (!prefersReducedMotion) {
          frames.forEach(function (frame) {
            frame.style.transition =
              'opacity 0.05s linear, transform 0.4s ease-out';
            frame.style.transform = 'translate(0px, 0px)';
          });

          setTimeout(function () {
            frames.forEach(function (frame) {
              frame.style.transition = 'opacity 0.05s linear';
            });
          }, 400);
        }
      }

      function handleMouseEnter() {
        if (!prefersReducedMotion) {
          frames.forEach(function (frame) {
            frame.style.transition = 'opacity 0.05s linear';
          });
        }
      }

      function startMobileAutoplay() {
        if (prefersReducedMotion) return;
        stopMobileAutoplay();
        mobileTimer = setInterval(advanceFrame, mobileInterval);
      }

      function stopMobileAutoplay() {
        if (mobileTimer) {
          clearInterval(mobileTimer);
          mobileTimer = null;
        }
      }

      function init() {
        isMobile = window.matchMedia('(max-width: 991px)').matches;

        if (isMobile) {
          trackerArea.removeEventListener('mousemove', handleMouseMove);
          trackerArea.removeEventListener('mouseleave', handleMouseLeave);
          trackerArea.removeEventListener('mouseenter', handleMouseEnter);
          startMobileAutoplay();
        } else {
          stopMobileAutoplay();
          trackerArea.addEventListener('mousemove', handleMouseMove);
          trackerArea.addEventListener('mouseleave', handleMouseLeave);
          trackerArea.addEventListener('mouseenter', handleMouseEnter);
        }
      }

      window.matchMedia('(max-width: 991px)').addEventListener('change', init);
      init();
    });

    const popupBtn = document.querySelector('.main-aos .aos-inner .btn');
    const popupDiv = document.querySelector('.aos-popup');

    if (popupBtn && popupDiv) {
        popupBtn.addEventListener('click', function() {
            popupDiv.classList.add('active');
            popupDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    const tops = document.querySelectorAll('.aos-popup .top-popup ul li button');
    const bottoms = document.querySelectorAll('.aos-popup .bottom-top-popup ul li');

    const gridItems = document.querySelectorAll('.aos-popup .inner-main-grid .inner-grid');

    // Sort grid items alphabetically by title
    const gridSortContainer = document.querySelector('.inner-main-grid');
    if (gridSortContainer) {
      Array.from(gridSortContainer.querySelectorAll('.inner-grid'))
        .sort((a, b) => {
          const ta = a.dataset.title || '';
          const tb = b.dataset.title || '';
          if (!ta && !tb) return 0;
          if (!ta) return 1;
          if (!tb) return -1;
          return ta.localeCompare(tb);
        })
        .forEach(item => gridSortContainer.appendChild(item));
    }

    // Recompute counts from actual rendered items (Liquid counts can be off due to Locksmith)
    document.querySelectorAll('.top-popup button[data-id]').forEach(function(btn) {
      const storeId = btn.getAttribute('data-id');
      const countEl = btn.querySelector('.count');
      if (!countEl) return;
      const count = storeId === 'all'
        ? gridItems.length
        : Array.from(gridItems).filter(function(item) { return item.getAttribute('data-id') === storeId; }).length;
      countEl.textContent = '(' + count + ')';
    });

    // Initial show all
    gridItems.forEach(item => item.classList.add('active'));

    tops.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        const parentLi = this.parentElement;
        const dataId = this.getAttribute('data-id');

        const topSiblings = parentLi.parentElement.children;
        for (let i = 0; i < topSiblings.length; i++) {
          topSiblings[i].classList.remove('active');
          const siblingBtn = topSiblings[i].querySelector('button');
          if (siblingBtn) siblingBtn.removeAttribute('aria-current');
        }
        
        parentLi.classList.add('active');
        this.setAttribute('aria-current', 'true');

        // Text blocks filter
        bottoms.forEach(function(li) {
          li.classList.remove('active');
          if (dataId && li.getAttribute('data-id') === dataId) {
            li.classList.add('active');
          }
        });

        // Grid images filter
        gridItems.forEach(function(item) {
          item.classList.remove('active');
          if (dataId === 'all') {
            item.classList.add('active');
          } else if (dataId && item.getAttribute('data-id') === dataId) {
            item.classList.add('active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const wrapper = this.nextElementSibling;
        if (!expanded) {
          faqQuestions.forEach(otherQuestion => {
            if (otherQuestion !== this) {
              otherQuestion.setAttribute('aria-expanded', 'false');
              otherQuestion.nextElementSibling.style.maxHeight = '0px';
            }
          });
        }
        
        if (expanded) {
          this.setAttribute('aria-expanded', 'false');
          wrapper.style.maxHeight = '0px';
        } else {
          this.setAttribute('aria-expanded', 'true');
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        }
      });
    });


    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const target = document.getElementById(id);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-row-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let mrwt_splide = new Splide('.mrwt-wrap', {
      type: 'slide',
      autoWidth: true,
      pagination: false,
      arrows: false,
      destroy: true,
      breakpoints: {
        991: {
          destroy: false,
          perMove: 1,
          flickMaxPages: 1,
          flickPower: 100,
        }
      }
    });
    let bar = document.querySelector('.mrwt-wrap .splide-progress-bar');
    const mrwtPrev = document.querySelector('.mrwt-arrow-prev');
    const mrwtNext = document.querySelector('.mrwt-arrow-next');
    mrwt_splide.on('mounted move', function () {
      let end  = mrwt_splide.Components.Controller.getEnd() + 1;
      let rate = Math.min((mrwt_splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
      if (mrwtPrev) mrwtPrev.disabled = mrwt_splide.index === 0;
      if (mrwtNext) mrwtNext.disabled = mrwt_splide.index >= mrwt_splide.Components.Controller.getEnd();
    });
    if (mrwtPrev) mrwtPrev.addEventListener('click', () => mrwt_splide.go('<'));
    if (mrwtNext) mrwtNext.addEventListener('click', () => mrwt_splide.go('>'));
    mrwt_splide.mount();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature"] && !Shopify.designMode) return;
  try {
    
  function initProductFeature(container = document) {
    const sections = container.querySelectorAll('.section-product-feature');
    sections.forEach(section => {
      const splideElement = section.querySelector('.product-feature.splide');
      if (!splideElement) return;
      let product_feature = new Splide(splideElement, {
        type: 'slide',
        autoWidth: true,
        pagination: false,
        arrows: false,
        destroy: true,
        breakpoints: {
          991: {
            destroy: false,
          },
        }
      });
      let bar = section.querySelector('.splide-progress-bar');
      const pfPrev = section.querySelector('.pf-arrow-prev');
      const pfNext = section.querySelector('.pf-arrow-next');
      product_feature.on('mounted move', function () {
        const controller = product_feature.Components.Controller;
        if (!controller) return;
        if (bar) {
          let end  = controller.getEnd() + 1;
          let rate = Math.min((product_feature.index + 1) / end, 1);
          bar.style.width = (100 * rate) + '%';
        }
        if (pfPrev) pfPrev.disabled = product_feature.index === 0;
        if (pfNext) pfNext.disabled = product_feature.index >= controller.getEnd();
      });
      if (pfPrev) pfPrev.addEventListener('click', () => product_feature.go('<'));
      if (pfNext) pfNext.addEventListener('click', () => product_feature.go('>'))
      product_feature.mount();
    });
  }
  document.addEventListener('DOMContentLoaded', () => initProductFeature());
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.classList.contains('shopify-section-header') || event.target.querySelector('.section-product-feature')) {
        initProductFeature(event.target);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
